import { AHIcon, AHIconType } from "./AHIcon";
import { ColorType } from "./AHTheme/AHTheme";
import { useMemo } from "react";
import { BaseButton } from "./BaseButton";

export type DialogButtonMode = "locked-active" | "inactive" | "active";

export function DialogButton(props: {
  children: React.ReactNode;
  indicatorIcon?: AHIconType;
  indicatorComponent?: React.ReactNode;
  trailing?: React.ReactNode;
  activeColor?: ColorType;
  mode: DialogButtonMode;
  onPress?: () => void;
  disablePadding?: boolean;
  indicatorSize?: number; // used for padding purposes
}) {
  const mode = props.mode;

  const textColor = useMemo(() => {
    if (mode === "inactive") {
      return "text-secondary";
    }

    return props.activeColor ?? "text-primary";
  }, [mode, props.activeColor]);

  const borderColor = useMemo((): ColorType => {
    if (mode !== "active") {
      return "transparent";
    }

    return "border-primary";
  }, [mode]);

  const background = useMemo((): ColorType => {
    if (mode === "inactive") {
      return "background";
    }

    return "transparent";
  }, [mode]);

  return (
    <BaseButton
      borderColor={borderColor}
      background={background}
      disabled={props.mode === "locked-active" || !props.onPress}
      onPress={props.onPress}
      indicatorSize={props.indicatorSize}
    >
      {props.indicatorIcon ? (
        <AHIcon type={props.indicatorIcon} size="xsmall" color={textColor} />
      ) : (
        props.indicatorComponent
      )}

      {props.children != null ? (
        <BaseButton.Label color={textColor}>{props.children}</BaseButton.Label>
      ) : null}
      {props.trailing}
    </BaseButton>
  );
}
